



import { useNavigate, useSearchParams } from 'react-router-dom';
import { PermissionContext } from 'components/Global/AuthLayout';
import { useContext, useEffect, useMemo, useState } from 'react';
import RunPayrollComponent from 'components/Payroll/RunPayroll';
import { toastText } from 'utils/utils';
import { Loader } from 'components/Global';

export const RunPayroll = () => {
	const navigate = useNavigate();
	const context = useContext(PermissionContext);
	const [searchParams] = useSearchParams();

	const [permissionsLoaded, setPermissionsLoaded] = useState(false);

	const payrollId = searchParams.get('payrollId');
	const onlyView = searchParams.get('onlyView');

	const permissions = useMemo(
		() => ({
			add: context.allowedPermissions.includes('Add_Run_Payroll'),
			edit: context.allowedPermissions.includes('Edit_Run_Payroll'),
			view: context.allowedPermissions.includes('View_Run_Payroll'),
		}),
		[context.allowedPermissions]
	);

	const hasAnyAccess =
		permissions.add || permissions.edit || permissions.view;

	useEffect(() => {
		if (context.allowedPermissions.length > 0) {
			setPermissionsLoaded(true);
		}
	}, [context.allowedPermissions]);

	useEffect(() => {
		if (!permissionsLoaded) return;

		if (payrollId) {
			if (onlyView !== 'true' && !permissions.edit) {
				navigate(`/run-payroll?payrollId=${payrollId}&onlyView=true`);
			}
		} else if (!permissions.add) {
			toastText('Missing Permission', 'error');
			navigate('/');
		}
	}, [
		permissionsLoaded,
		searchParams,
		permissions.edit,
		permissions.add,
		navigate,
	]);

	if (!permissionsLoaded) {
		return (
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					height: '85vh',
				}}
			>
				<Loader />
			</div>
		);
	}

	return <>{hasAnyAccess && <RunPayrollComponent />}</>;
};
